import { render } from "./FireRosterPage.vue?vue&type=template&id=03c7cf8e&scoped=true"
import script from "./FireRosterPage.vue?vue&type=script&lang=ts"
export * from "./FireRosterPage.vue?vue&type=script&lang=ts"

import "./FireRosterPage.vue?vue&type=style&index=0&id=03c7cf8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03c7cf8e"

export default script